var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',_vm._b({staticClass:"input",attrs:{"maxlength":_vm.max,"placeholder":_vm.labelVal},domProps:{"value":_vm.value},on:{"keyup":_vm.onInput,"input":_vm.numberChk}},'input',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }